import exponent from "./exponent.js";

export default function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-format/src/precisionRound.js
// module id = 1168
// module chunks = 0